import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './statusMessage.scss';
import { Infobox } from '../../novasoldev/infobox/src';
import cx from 'classnames';

import SvgPayApproved from './svg/payment_approved.svg';
import SvgPaylined from './svg/payment_denied.svg';
import SvgCheckmark from './svg/icon__checkmark_green.svg';

// Could become more generic message component if needed
const StatusMessage = ({ labels }) => {

  let titleResult = '';
  let messageResult = '';
  let type = 'status';
  let cssModifier = '';
  let icon;

  const [message, setMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.get('callbackMessage')) {
      setMessage(params.get('callbackMessage'));
    }
  },
  [window.location.search]);

  const handleCloseMessage = () => {
    // const params = new URLSearchParams(window.location.search);
    // params.delete('callbackMessage'); // TODO: fix it
    // history.push(`${location.pathname}?${params}`);
    setMessage(false);
  };


  switch (message) {
    case 'success':
      type = 'success';
      titleResult = labels.paymentSuccessfulTitle;
      messageResult = labels.paymentSuccessful;
      icon = (
        <SvgPayApproved
          aria-hidden="true"
          className="statusMessage__icon--success"
        />
      );
      break;

    case 'decline':
      type = 'fail';
      titleResult = labels.paymentDeclineTitle;
      messageResult = labels.paymentDecline;
      icon = (
        <SvgPaylined aria-hidden="true" className="statusMessage__icon--fail" />
      );
      break;

    case 'arrivalInfoUpdateSuccess':
      type = 'success';
      cssModifier = 'infobox--checkmark';
      titleResult = labels.arrivalFormSuccessMessageTitle;
      messageResult = labels.arrivalFormSuccessMessage;
      icon = (
        <SvgCheckmark
          aria-hidden="true"
          className="statusMessage__icon--checkmark"
        />
      );
      break;

    default:
      icon = null;
      messageResult = null;
  }

  const infoboxClass = cx({
    [type]: !cssModifier.length,
    [`${type} ${cssModifier}`]: cssModifier.length,
  });

  return messageResult ? (
    <div className="statusMessage column">
      <Infobox
        closeButtonClick={handleCloseMessage}
        cssModifier={infoboxClass}
        icon={icon}
        text={messageResult}
        title={titleResult}
        variant={type}
      />
    </div>
  ) : null;
};

StatusMessage.PropTypes = {
  labels:PropTypes.shape({
    paymentSuccessfulTitle:PropTypes.string,
    paymentSuccessful:PropTypes.string,
    paymentDeclineTitle:PropTypes.string,
    paymentDecline:PropTypes.string,
    arrivalFormSuccessMessageTitle:PropTypes.string,
    arrivalFormSuccessMessage:PropTypes.string,
  }),
};

export default StatusMessage;
